// extracted by mini-css-extract-plugin
export var blob = "shapes-module--blob--a8322";
export var blobLeft = "shapes-module--blob-left--8e4b8";
export var chatArrowPink = "shapes-module--chat-arrow-pink--85bc1";
export var chatArrowPurple = "shapes-module--chat-arrow-purple--dc31b";